window.variablesComponent = ({t_id, pattern, root_route}) => ({
    variables: [],
    t_id: t_id,
    pattern: pattern,
    root_route: root_route,
    async init() {
        await this.fetchVariables()
    },
    async fetchVariables() {
        try {
            const {data} = await axios.get(route(this.root_route + '.mail_templates.variables.index', {'mail_template': this.t_id}))
            this.variables = data.variables
        } catch (e) {
            httpExceptionHandler(e)
        }
    },
})

window.variableRow = (variable = {}) => ({
    variable: variable,
    oldItem: null,
    errors: {},
    isValid() {
        return this.variable.name && this.variable.match;
    },
    copyName() {
        /*todo: fix copy-paste variable*/
        const area = document.getElementById('template')
        // area.focus()
        area.addEventListener('click', ({target: area}) => {
            const prefix = this.pattern.prefix || '{{';
            const suffix = this.pattern.suffix || '}}';

            area.setRangeText(prefix + this.variable.name + suffix, area.selectionStart, area.selectionStart, 'select')
            area.dispatchEvent(new Event('input'))
        }, {once: true})

        toastr.info($t('messages.variables.name_copied'))
    },
    edit() {
        this.oldItem = Object.assign({}, this.variable)

        this.variable.is_editing = true
    },
    cancel() {
        this.variable = Object.assign({}, this.oldItem)

        this.variable.is_editing = false
    },
    async create() {
        if (!this.isValid(this.variable)) {
            return false;
        }

        try {
            const {data} = await axios.post(route(this.root_route + '.mail_templates.variables.create', {'mail_template': this.t_id}),
                this.variable
            )

            this.variable = {}
            toastr.success(data.message)

            await this.fetchVariables()

        } catch (e) {
            httpExceptionHandler(e)
            this.errors = getValidationErrors(e)
        }
    },
    async store() {
        if (!this.isValid(this.variable)) {
            return false;
        }

        try {
            const {data} = await axios.post(route(this.root_route + '.mail_templates.variables.update', {
                'mail_template': this.t_id,
                'variable': this.variable.id
            }), this.variable)

            this.variable.is_editing = false

            toastr.success(data.message)

            debugger

            await this.fetchVariables()

        } catch (e) {
            httpExceptionHandler(e)
            this.errors = getValidationErrors(e)
        }
    },
    async destroy() {
        if (this.variable.is_deleted) {
            return;
        }

        if (!confirm($t('messages.confirm.delete'))) {
            return;
        }

        try {
            const {data} = await axios.delete(route(this.root_route + '.mail_templates.variables.delete', {
                'mail_template': this.t_id,
                'variable': this.variable.id
            }))

            toastr.success(data.message)
            this.variable = {is_deleted: true}

            await this.fetchVariables()

        } catch (e) {
            httpExceptionHandler(e)
        }
    },
})
